import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store, select } from '@ngrx/store';

import * as actions from '../actions/account-owner-collection.actions';
import * as selectors from '../selectors';

import { filter, first, switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable()
export class AccountOwnerCollectionResolver implements Resolve<boolean> {
  constructor(private store: Store<any>) {}

  resolve(): Observable<boolean> {
    return this.store.pipe(
      select(selectors.getAccountOwnerCollectionLoaded),
      withLatestFrom(this.store.pipe(select(selectors.getAccountOwnerCollectionLoading))),
      switchMap(([loaded, loading]) => {
        if (loaded) {
          return of(true);
        }

        if (loading === false) {
          this.store.dispatch(actions.load({}));
        }

        return this.store.pipe(
          select(selectors.getAccountOwnerCollectionLoaded),
          filter((l1) => l1 === true)
        );
      }),
      first()
    );
  }
}
